import ProductCurrentCard from './ProductCurrentCard';

export default ProductCurrentCard;
